// CollabCampaignDetails.js
import React, { useState, useEffect, useRef } from 'react';
import {
  SafeAreaView,
  Image,
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Clipboard,
  ScrollView,
  TextInput,
  Alert,
  Modal,
  Linking,
  Animated,
  ActivityIndicator,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

const CollabCampaignDetails = ({ route, navigation }) => {
const CollabID = route?.params?.CollabID;

  const [userData, setUserData] = useState({});
  const [promoterEmail, setPromoterEmail] = useState(null);
  const [promoterName, setPromoterName] = useState(null);
  const [message, setMessage] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('7:00 AM');
  const [latestUpdate, setLatestUpdate] = useState({
  Message: '',
  CreditAvailableStart: '',
  Status: '',
  AddedVisitors: '',
  LastUpdateFrom: '',
  CreatorFirstName: '',
  CreatorLastName: '',
  CreatorPhoneNumber: '',
  IsProposal: '',
});
  const [mediaContent, setMediaContent] = useState([]);
  const [profileImage, setProfileImage] = useState('');
  const [platformUsername, setPlatformUsername] = useState('');
  const [platformFollowers, setPlatformFollowers] = useState('');
  const [isRedeemed, setIsRedeemed] = useState(false);
  const [redeemDateTime, setRedeemDateTime] = useState(null);

  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [cancelMessage, setCancelMessage] = useState('');

  const [isExpanded, setIsExpanded] = useState(false);

  const [accountAdmin, setAccountAdmin] = useState('');

  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [updateModalMessage, setUpdateModalMessage] = useState('');
  const [isUpdateSuccessful, setIsUpdateSuccessful] = useState(false);

  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);
  const [approveModalMessage, setApproveModalMessage] = useState('');
  const [isApproveSuccessful, setIsApproveSuccessful] = useState(false);

  // ✅ Reward Delight popup states
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [acceptDuration, setAcceptDuration] = useState(0);
  const startTimeRef = useRef(Date.now());
  const scaleAnim = useRef(new Animated.Value(0)).current;

const scrollViewRef = useRef(null);


  const [isCancelSuccessModalVisible, setIsCancelSuccessModalVisible] =
    useState(false);
  const [cancelSuccessMessage, setCancelSuccessMessage] = useState('');

  const [isEmailCopied, setIsEmailCopied] = useState(false);

  const [chatMessages, setChatMessages] = useState([]);

  const [isChatModalVisible, setIsChatModalVisible] = useState(false);
  const [newChatMessage, setNewChatMessage] = useState('');
  const [isChatSending, setIsChatSending] = useState(false);

  const [listingID, setListingID] = useState('');
  const [listingLocation, setListingLocation] = useState('');

  const [onBehalfOf, setOnBehalfOf] = useState('');

  const [shareCopied, setShareCopied] = useState(false);

    const [creatorSocialProof, setCreatorSocialProof] = useState({
    badges: [],
    deliveredContentCount: 0,
    acceptedCount: 0,
    totalCollabsCount: 0,
    acceptedRatio: 0,
    promoter: '',
  });

  // NEW — Quick toast confirmation on approve
  const [quickToast, setQuickToast] = useState(false);

  // NEW — loading gate
  const [isLoading, setIsLoading] = useState(true);

  // 🔐 NEW — subscription / auth state for sidenav logic
  const [isAuthed, setIsAuthed] = useState(false); // true if authenticated (subscriber or preview)
  const [authMode, setAuthMode] = useState('none'); // "subscriber" | "preview" | "none"
  const [authChecked, setAuthChecked] = useState(false); // once we've hit the endpoint at least once
  const isSubscriber = authMode === 'subscriber';

  const buildShareRecap = () => {
    const brand = userData?.Username || 'Your venue';
    const when = latestUpdate?.CreditAvailableStart || 'TBC';
    const name = promoterName || platformUsername || 'Creator';
    const followers = platformFollowers ? `${platformFollowers}` : 'N/A';
    const igUrl = platformUsername
      ? `https://instagram.com/${platformUsername}/reels`
      : 'N/A';
    const loc =
      listingLocation && listingLocation.trim() !== ''
        ? listingLocation
        : 'N/A';

    return (
      `Hey, there is a new Influencer booking request for ${brand} — quick recap:\n` +
      `• When: ${when}\n` +
      `• Creator: ${name}\n` +
      `• Followers: ${followers}\n` +
      `• Instagram: ${igUrl}\n` +
      `• Location: ${loc}`
    );
  };

  const handleShareCopy = () => {
    const text = buildShareRecap();
    Clipboard.setString(text);
    setShareCopied(true);
    setTimeout(() => setShareCopied(false), 1400);
  };

  useEffect(() => {
    if (route.params?.openChatModal) {
      setIsChatModalVisible(true);
    }
  }, [route.params]);

  const handleCopyEmail = () => {
    if (promoterEmail) {
      Clipboard.setString(promoterEmail);
      setIsEmailCopied(true);

      setTimeout(() => setIsEmailCopied(false), 2000);
    } else {
      alert('No email address to copy.');
    }
  };

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };


  const handleJumpToMoveOptions = () => {
  setIsExpanded(true);

  setTimeout(() => {
    if (typeof document !== 'undefined') {
      const target = document.getElementById('moveCancelSection');

      if (target && target.scrollIntoView) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        return;
      }
    }

    if (scrollViewRef.current?.scrollToEnd) {
      scrollViewRef.current.scrollToEnd({ animated: true });
    }
  }, 250);
};

  const [activeTab, setActiveTab] = useState('CodeSystem');

  const fetchAccountAdmin = () => {
    return fetch(
      'https://collabbayadmin.com/APIControllers/GetVenueAccountAdmin.php',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setAccountAdmin(data.AccountAdmin);
        } else {
          console.error('Error fetching AccountAdmin:', data.message);
        }
      })
      .catch((error) => console.error('Error:', error));
  };

  const fetchPromoterEmail = (promoterName) => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/GetCollabPromoterEmail.php?Promoter=${promoterName}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0] && data[0].UserEmail) {
          setPromoterEmail(data[0].UserEmail);
        } else {
          console.error('Promoter email not found');
        }
      })
      .catch((error) => console.error('Error fetching promoter email:', error));
  };

  const fetchPromoterProfile = (promoterName) => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/ShowPromoterProfile.php?Promoter=${promoterName}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          const profileData = data[0];
          setProfileImage(profileData.ProfileImage);
          setPlatformUsername(profileData.PlatformUsername);
          setPlatformFollowers(profileData.PlatformFollowers);
        } else {
          console.error('Promoter profile data not found');
        }
      })
      .catch((error) =>
        console.error('Error fetching promoter profile:', error)
      );
  };

  const fetchPromoterDetails = () => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/GetCollabPromoterName.php?CollabID=${CollabID}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0] && data[0].Promoter) {
          const fetchedPromoter = data[0].Promoter;
          setPromoterName(fetchedPromoter);
          fetchPromoterEmail(fetchedPromoter);
          fetchPromoterProfile(fetchedPromoter);
        } else {
          console.error('Promoter name not found');
        }
      })
      .catch((error) => console.error('Error fetching promoter name:', error));
  };


  const fetchCreatorSocialProof = () => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/GetCreatorSocialProof.php?CollabID=${encodeURIComponent(
        CollabID
      )}`,
      {
        method: 'GET',
        credentials: 'include',
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setCreatorSocialProof({
            badges: Array.isArray(data.badges) ? data.badges : [],
            deliveredContentCount: Number(
              data.metrics?.deliveredContentCount || 0
            ),
            acceptedCount: Number(data.metrics?.acceptedCount || 0),
            totalCollabsCount: Number(data.metrics?.totalCollabsCount || 0),
            acceptedRatio: Number(data.metrics?.acceptedRatio || 0),
            promoter: data.promoter || '',
          });
        } else {
          console.error('Error fetching creator social proof:', data.message);
        }
      })
      .catch((error) =>
        console.error('Error fetching creator social proof:', error)
      );
  };


const trackBrandBookingView = () => {
  return fetch(
    `https://collabbayadmin.com/APIControllers/TrackBrandBookingView.php?CollabID=${encodeURIComponent(
      CollabID
    )}`,
    {
      method: 'GET',
      credentials: 'include',
    }
  )
    .then((response) => response.json())
    .then((data) => {
      if (!data.success) {
        console.error('Booking view tracking failed:', data.message);
      }
    })
    .catch((error) => {
      console.error('Error tracking booking view:', error);
    });
};

  const fetchUserData = () => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/GetSessionData.php?CollabID=${CollabID}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.Username) {
          setUserData(data);
        } else {
          console.error('Username not found in response');
        }
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  };

  const fetchLatestCollabUpdate = () => {
    return fetch(
      `https://collabbay.com/APIControllers/GetLatestCollabUpdate.php?CollabID=${CollabID}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
       setLatestUpdate({
  Message: data.Message || '',
  CreditAvailableStart: data.CreditAvailableStart || '',
  Status: data.Status || '',
  AddedVisitors: data.AddedVisitors || '',
  LastUpdateFrom: data.LastUpdateFrom || '',
  CreatorFirstName: data.CreatorFirstName || '',
  CreatorLastName: data.CreatorLastName || '',
  CreatorPhoneNumber: data.CreatorPhoneNumber || '',
  IsProposal: data.IsProposal || '',
});

          setListingID(data.ListingID);
          const messages = data.Message
            ? data.Message.split('|||').map((msg) => {
                const [user, text] = msg.split(': ');
                return { user, text };
              })
            : [];
          setChatMessages(messages);
        }
      })
      .catch((error) =>
        console.error('Error fetching latest collab update:', error)
      );
  };

  const fetchMediaContent = () => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/GetCollabMedia.php?CollabID=${CollabID}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.length > 0) {
          setMediaContent(data);
        } else {
          console.log('No media content found');
        }
      })
      .catch((error) => {
        console.error('Error fetching media content:', error);
      });
  };

  const checkRedeemStatus = () => {
    return fetch(
      `https://collabbayadmin.com/APIControllers/CheckCollabRedeemedStatus.php?CollabID=${CollabID}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.message === 'Redeem Found') {
          setIsRedeemed(true);
          setRedeemDateTime(data.dateTime);
        }
      })
      .catch((error) => console.error('Error fetching redeem status:', error));
  };

  // 🔐 Fetch auth state for sidenav gating
  const fetchAuthState = () => {
    return fetch(
      'https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php',
      {
        method: 'GET',
        credentials: 'include',
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const authed =
          typeof data.authenticated === 'boolean'
            ? data.authenticated
            : data.status === 'active';
        const mode = data.auth_mode
          ? data.auth_mode
          : data.status === 'active'
          ? 'subscriber'
          : 'none';

        setIsAuthed(!!authed);
        setAuthMode(mode);
      })
      .catch((err) => {
        console.error('Error fetching auth state:', err);
      })
      .finally(() => {
        setAuthChecked(true);
      });
  };



  useEffect(() => {
  if (!CollabID) return;

  let isActive = true;

  const resetBookingState = () => {
    setIsLoading(true);

    setUserData({});
    setPromoterEmail(null);
    setPromoterName(null);
    setMessage('');
    setSelectedDate('');
    setSelectedTime('7:00 AM');

   setLatestUpdate({
  Message: '',
  CreditAvailableStart: '',
  Status: '',
  AddedVisitors: '',
  LastUpdateFrom: '',
  CreatorFirstName: '',
  CreatorLastName: '',
  CreatorPhoneNumber: '',
  IsProposal: '',
});

    setMediaContent([]);
    setProfileImage('');
    setPlatformUsername('');
    setPlatformFollowers('');
    setIsRedeemed(false);
    setRedeemDateTime(null);
    setChatMessages([]);
    setListingID('');
    setListingLocation('');
    setOnBehalfOf('');

    setCreatorSocialProof({
      badges: [],
      deliveredContentCount: 0,
      acceptedCount: 0,
      totalCollabsCount: 0,
      acceptedRatio: 0,
      promoter: '',
    });
  };

  const loadInitialData = async () => {
    resetBookingState();

    try {
    await Promise.all([
  trackBrandBookingView(),
  fetchUserData(),
  fetchPromoterDetails(),
  fetchCreatorSocialProof(),
  fetchLatestCollabUpdate(),
  fetchMediaContent(),
  checkRedeemStatus(),
  fetchAccountAdmin(),
  fetchAuthState(),
]);
    } catch (error) {
      console.error('Error loading collab details:', error);
    } finally {
      if (isActive) {
        setIsLoading(false);
      }
    }
  };

  loadInitialData();

  return () => {
    isActive = false;
  };
}, [CollabID]);

  const [isHowToCollabVisible, setIsHowToCollabVisible] = useState(false);

  const toggleHowToCollabVisibility = () => {
    setIsHowToCollabVisible((prevState) => !prevState);
  };

  const [sendSuccess, setSendSuccess] = useState(false);

  const handleSendChatMessage = () => {
    if (!newChatMessage.trim()) {
      alert('Please enter a message.');
      return;
    }

    setIsChatSending(true);

    fetch(
      `https://collabbayadmin.com/APIControllers/UserUpdateCollabChat.php?CollabID=${CollabID}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Message: newChatMessage }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setNewChatMessage('');
          fetchLatestCollabUpdate();
          setSendSuccess(true);
          setTimeout(() => {
            setSendSuccess(false);
            setIsChatModalVisible(false);
          }, 1000);
        } else {
          alert(data.message || 'Failed to send message.');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('An error occurred. Please try again.');
      })
      .finally(() => {
        setIsChatSending(false);
      });
  };

  const handleCancelBooking = () => {
    const fullDateTime = new Date().toISOString();

    fetch(
      `https://collabbayadmin.com/APIControllers/UserCancelCollab.php?CollabID=${CollabID}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Message: cancelMessage,
          CreditAvailableStart: fullDateTime,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setCancelSuccessMessage('Cancellation Sent');
          setIsCancelSuccessModalVisible(true);
          setIsCancelModalVisible(false);
        } else {
          setCancelSuccessMessage(
            'There was an error processing your cancellation.'
          );
          setIsCancelSuccessModalVisible(true);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setCancelSuccessMessage('An unexpected error occurred.');
        setIsCancelSuccessModalVisible(true);
      });
  };

  const toggleCancelModal = () => {
    setIsCancelModalVisible(!isCancelModalVisible);
  };

  const getCollabStatus = (collab) => {
    const today = new Date();
    const creditAvailableDate = new Date(collab.CreditAvailableStart);

    if (isRedeemed) {
      return 'Redeemed';
    }

    if (collab.Status === 'Cancelled') {
      return 'Cancelled';
    }

    if (creditAvailableDate < today && collab.Status === 'Accepted') {
      return 'Expired';
    }

    if (collab.Status === 'Accepted') {
      return 'Upcoming';
    }

    return collab.Status === 'Pending' ? 'Pending' : collab.Status || 'Pending';
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Redeemed':
        return styles.redeemedStatus;
      case 'Expired':
        return styles.expiredStatus;
      case 'Upcoming':
        return styles.upcomingStatus;
      case 'Pending':
        return styles.pendingStatus;
      case 'Cancelled':
        return styles.cancelledStatus;
      default:
        return null;
    }
  };

  // ✨ Tiny AI summary sentence (simplified)
  const getAISummary = () => {
    const status = (latestUpdate.Status || '').toLowerCase();
    const creator = promoterName || platformUsername || 'this creator';

    let whenExtra = '';
    if (latestUpdate.CreditAvailableStart) {
      const visitDate = new Date(latestUpdate.CreditAvailableStart);
      if (!isNaN(visitDate.getTime())) {
        const today = new Date();
        const oneDayMs = 24 * 60 * 60 * 1000;
        const diffDays = Math.round(
          (visitDate.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0)) /
            oneDayMs
        );

        if (diffDays > 1) {
          whenExtra = ` in ${diffDays} days`;
        } else if (diffDays === 1) {
          whenExtra = ' tomorrow';
        } else if (diffDays === 0) {
          whenExtra = ' today';
        } else if (diffDays === -1) {
          whenExtra = ' (visited 1 day ago)';
        } else if (diffDays < -1) {
          whenExtra = ` (visited ${Math.abs(diffDays)} days ago)`;
        }
      }
    }

   if (status === 'pending') {
  if (isProposal) {
    if (whenExtra.includes('in ')) {
      return `Proposed for ${whenExtra.replace(' in ', '')} from now.`;
    }

    if (whenExtra === ' tomorrow') {
      return 'Proposed for tomorrow.';
    }

    if (whenExtra === ' today') {
      return 'Proposed for today.';
    }

    return 'Proposed booking slot.';
  }

  return `${creator} wants to visit${whenExtra}.`;
}
    if (status === 'accepted' || status === 'upcoming') {
      return `${creator} is booked in${whenExtra}.`;
    }
    if (status === 'cancelled') {
      return `This collab has been cancelled.`;
    }
    if (status === 'redeemed') {
      return `${creator} has already visited and redeemed.`;
    }

    return `Quick recap so you can review this collab at a glance.`;
  };

  const handleCopyURL = () => {
    Clipboard.setString(`https://collabbay.com/collab/${CollabID}`);
    alert('Collab link copied to clipboard');
  };

const handleBackPress = () => {
  if (navigation?.canGoBack && navigation.canGoBack()) {
    navigation.goBack();
    return;
  }

  navigation.navigate('MyPanel');
};

  const renderDatePicker = () => {
    const dates = [];
    const today = new Date();

    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() + i);
      dates.push(date.toDateString());
    }

    return (
      <View style={styles.datePickerContainer}>
        <Text style={styles.datePickerLabel}>Move Booking Date</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {dates.map((date, index) => (
            <TouchableOpacity
              key={index}
              style={[
                styles.dateOption,
                { backgroundColor: selectedDate === date ? '#FDF05D' : 'white' },
              ]}
              onPress={() => setSelectedDate(date)}
            >
              <Text style={styles.dateOptionText}>{date}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    );
  };

  const renderTimePicker = () => {
    return (
      <View style={styles.timePickerContainer}>
        <Text style={styles.timePickerLabel}>Select New Time</Text>
        <ScrollView
          style={styles.timeScrollView}
          showsVerticalScrollIndicator={false}
        >
          {Array.from({ length: 40 }, (_, i) => {
            const hour = Math.floor((i + 14) / 2) % 24;
            const minute = i % 2 === 0 ? '00' : '30';
            const ampm = hour >= 12 ? 'PM' : 'AM';
            const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;
            const timeLabel = `${adjustedHour}:${minute} ${ampm}`;

            return (
              <TouchableOpacity
                key={i}
                style={[
                  styles.timeSlot,
                  selectedTime === timeLabel && styles.selectedTimeSlot,
                ]}
                onPress={() => setSelectedTime(timeLabel)}
              >
                <Text>{timeLabel}</Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>
    );
  };

  const handleSubmit = () => {
    const fullDateTime = `${selectedDate} ${selectedTime}`;

    fetch(
      `https://collabbayadmin.com/APIControllers/AdminUpdateCollab.php?CollabID=${CollabID}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Message: message,
          CreditAvailableStart: fullDateTime,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setUpdateModalMessage(
            'Update request sent successfully. The creator has been notified.'
          );
          setIsUpdateSuccessful(true);
        } else {
          setUpdateModalMessage(
            'Error: Unable to update the booking. Please try again.'
          );
          setIsUpdateSuccessful(false);
        }
        setIsUpdateModalVisible(true);
      })
      .catch((error) => {
        console.error('Error:', error);
        setUpdateModalMessage(
          'An unexpected error occurred. Please try again.'
        );
        setIsUpdateSuccessful(false);
        setIsUpdateModalVisible(true);
      });
  };

  const renderMediaContent = () => {
    if (mediaContent.length === 0) return null;

    return (
      <View style={styles.mediaContentSection}>
        {mediaContent.map((item, index) => (
          <View key={index} style={styles.mediaItemContainer}>
            <Image
              style={styles.mediaImage}
              source={{ uri: item.Image }}
              resizeMode="cover"
            />

            <View style={styles.mediaContentTextSection}>
              <TouchableOpacity
                onPress={() => handleMediaItemClick(item.PostURL)}
                style={styles.linkButton}
              >
                <Ionicons
                  name="link"
                  size={20}
                  color="black"
                  style={styles.linkIcon}
                />
                <Text style={styles.mediaLinkText}>Click to view content</Text>
              </TouchableOpacity>

              <Text style={styles.mediaMessageText}>
                <Ionicons
                  name="chatbubble-ellipses"
                  size={20}
                  color="black"
                />{' '}
                {item.Message}
              </Text>

              <TouchableOpacity
                onPress={() => handleMediaDownload(item.Image)}
                style={styles.downloadButton}
              >
                <Ionicons name="download-outline" size={24} color="black" />
                <Text style={styles.downloadText}>Download</Text>
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </View>
    );
  };

  const handleMediaItemClick = (url) => {
    const formattedURL = url.startsWith('http') ? url : `https://${url}`;
    Linking.openURL(formattedURL).catch((err) =>
      console.error('Failed to open URL:', err)
    );
  };

  const handleMediaDownload = (url) => {
    try {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.substring(url.lastIndexOf('/') + 1) || 'media-content';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading media:', error);
      alert('An error occurred while downloading the media.');
    }
  };

  // Reveal animation control
  const [showRevealCover, setShowRevealCover] = useState(false);
  const revealScale = useState(new Animated.Value(1))[0];
  const revealRotate = useState(new Animated.Value(0))[0];
  const revealOpacity = useState(new Animated.Value(1))[0];
  const profileScale = useState(new Animated.Value(0.8))[0];
  const profileOpacity = useState(new Animated.Value(0))[0];

  // ✅ New Move Date modal state
  const [isMoveModalVisible, setIsMoveModalVisible] = useState(false);

  // Start reveal AFTER loading is done
  useEffect(() => {
    if (!isLoading) {
      setShowRevealCover(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (showRevealCover) {
      Animated.sequence([
        Animated.loop(
          Animated.sequence([
            Animated.timing(revealRotate, {
              toValue: 1,
              duration: 100,
              useNativeDriver: true,
            }),
            Animated.timing(revealRotate, {
              toValue: -1,
              duration: 100,
              useNativeDriver: true,
            }),
            Animated.timing(revealRotate, {
              toValue: 0,
              duration: 100,
              useNativeDriver: true,
            }),
          ]),
          { iterations: 2 }
        ),
        Animated.parallel([
          Animated.timing(revealScale, {
            toValue: 1.5,
            duration: 600,
            useNativeDriver: true,
          }),
          Animated.timing(revealOpacity, {
            toValue: 0,
            duration: 600,
            useNativeDriver: true,
          }),
        ]),
        Animated.parallel([
          Animated.timing(profileScale, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
          }),
          Animated.timing(profileOpacity, {
            toValue: 1,
            duration: 450,
            useNativeDriver: true,
          }),
        ]),
      ]).start(() => {
        setShowRevealCover(false);
      });
    }
  }, [
    showRevealCover,
    profileOpacity,
    profileScale,
    revealOpacity,
    revealRotate,
    revealScale,
  ]);

  const renderRevealAnimation = () => {
    const rotateInterpolate = revealRotate.interpolate({
      inputRange: [-1, 1],
      outputRange: ['-3deg', '3deg'],
    });

    if (!showRevealCover) return null;

    return (
      <Animated.View
        style={[
          styles.revealOverlay,
          {
            opacity: revealOpacity,
            transform: [{ scale: revealScale }, { rotate: rotateInterpolate }],
          },
        ]}
      >
        <View style={styles.revealCard} />
      </Animated.View>
    );
  };



  const renderPromoterProfile = () => {
  const handlePress = () => {
    if (!platformUsername) return;
    const url = `https://www.instagram.com/${platformUsername}/reels`;
    Linking.openURL(url).catch((err) =>
      console.error('Failed to open URL:', err)
    );
  };

  if (!profileImage && !platformUsername) return null;

  return (
    <Animated.View
      style={[
        styles.profileCard,
        {
          transform: [{ scale: profileScale }],
          opacity: profileOpacity,
        },
      ]}
    >
     {profileImage ? (
  <Image style={styles.profileImage} source={{ uri: profileImage }} />
) : null}

<Text style={styles.profileUsername}>{platformUsername}</Text>

{!!platformFollowers && (
  <Text style={styles.profileFollowers}>
    {platformFollowers} Followers
  </Text>
)}

{renderCreatorSocialProof()}

{platformUsername ? (
  <TouchableOpacity
    onPress={handlePress}
    style={styles.profileLinkButton}
  >
          <Ionicons name="logo-instagram" size={20} color="black" />
          <Text style={styles.profileLinkText}>View on Instagram</Text>
        </TouchableOpacity>
      ) : null}
    </Animated.View>
  );
};

  const renderRedeemStatus = () => {
    if (isRedeemed) {
      return (
        <View style={styles.redeemedContainer}>
          <Text style={styles.redeemedText}>Redeemed on {redeemDateTime}</Text>
        </View>
      );
    }
    return null;
  };



  const renderCreatorSocialProof = () => {
  if (!creatorSocialProof.badges || creatorSocialProof.badges.length === 0) {
    return null;
  }

  const getShortBadgeText = (badge) => {
    switch (badge.key) {
      case 'delivered_content':
        return `${creatorSocialProof.deliveredContentCount} content deliveries on collabbay`;
      case 'accepted_count':
        return `Booked by ${creatorSocialProof.acceptedCount} other venues on collabbay`;
      case 'accepted_ratio':
        return `${creatorSocialProof.acceptedRatio}% of venues accept this creator on collabbay`;
      default:
        return badge.text;
    }
  };

  return (
    <View style={styles.creatorSocialProofWrap}>
      {creatorSocialProof.badges.map((badge, index) => (
        <View key={`${badge.key}-${index}`} style={styles.creatorProofBadge}>
          <Ionicons
            name="checkmark-circle"
            size={19}
            color="#1D9BF0"
            style={styles.creatorProofIcon}
          />
          <Text style={styles.creatorProofText}>
            {getShortBadgeText(badge)}
          </Text>
        </View>
      ))}
    </View>
  );
};


const handleAcceptProposal = async () => {
  try {
    const res = await fetch(
      `https://collabbayadmin.com/APIControllers/ProposalApproval.php?CollabID=${CollabID}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      }
    );

    const data = await res.json();

    if (data.message !== 'Proposal converted to invite successfully.') {
      setIsApproveSuccessful(false);
      setApproveModalMessage(
        data.message || 'Failed to accept the proposal.'
      );
      setIsApproveModalVisible(true);
      return;
    }

    setIsApproveSuccessful(true);
    setApproveModalMessage(
      'Proposal accepted. This has now been sent to the creator as an invite. The booking is not confirmed until the creator accepts.'
    );
    setIsApproveModalVisible(true);

    fetchLatestCollabUpdate();
  } catch (err) {
    console.error('Error accepting proposal:', err);
    setIsApproveSuccessful(false);
    setApproveModalMessage(
      'An error occurred while accepting the proposal. Please try again.'
    );
    setIsApproveModalVisible(true);
  }
};

  const handleApproveCollab = async () => {
    try {
      const res = await fetch(
        `https://collabbayadmin.com/APIControllers/AdminApproveCollab.php?CollabID=${CollabID}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }
      );

      const data = await res.json();

      if (data.message !== 'Collab updated successfully.') {
        setIsApproveSuccessful(false);
        setApproveModalMessage(
          data.message || 'Failed to approve the collaboration.'
        );
        setIsApproveModalVisible(true);
        return;
      }

      setIsApproveSuccessful(true);
      setIsApproveModalVisible(false);

      const authRes = await fetch(
        'https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php',
        {
          method: 'GET',
          credentials: 'include',
        }
      );

      const authJson = await authRes.json();
      const isSubscribed = authJson.status === 'active';

      if (isSubscribed) {
        handleAcceptCollabSuccess();
        return;
      }

      const statsRes = await fetch(
        'https://collabbayadmin.com/APIControllers/CheckUserPsyche.php',
        {
          method: 'GET',
          credentials: 'include',
        }
      );

      const stats = await statsRes.json();
      const acceptedCount = stats.accepted;

      if (acceptedCount === 1) {
        handleAcceptCollabSuccess();
        return;
      }

      if (acceptedCount === 2) {
        setQuickToast(true);
        setTimeout(() => {
          window.location.href = 'https://collabbayadmin.com/Forecast';
        }, 900);
        return;
      }

      if (acceptedCount >= 3) {
        const sessionRes = await fetch(
          'https://collabbayadmin.com/APIControllers/GetSessionData.php',
          { method: 'GET', credentials: 'include' }
        );
        const sessionJson = await sessionRes.json();

        const seenOffer = sessionJson.SeenOneTimeOffer || 'N';

        if (seenOffer !== 'Y') {
          window.location.href = 'https://collabbayadmin.com/subscribeoffer';
          return;
        }

        window.location.href = 'https://collabbayadmin.com/Forecast';
        return;
      }
    } catch (err) {
      console.error('Error:', err);
      setIsApproveSuccessful(false);
      setApproveModalMessage(
        'An error occurred while approving the collaboration. Please try again.'
      );
      setIsApproveModalVisible(true);
    }
  };

  const handleAcceptCollabSuccess = () => {
    const duration = ((Date.now() - startTimeRef.current) / 1000).toFixed(1);

    setIsApproveModalVisible(false);
    setAcceptDuration(duration);
    setShowSuccessModal(true);

    Animated.spring(scaleAnim, {
      toValue: 1,
      friction: 5,
      tension: 120,
      useNativeDriver: true,
    }).start();
  };

  useEffect(() => {
    if (!listingID || String(listingID).trim() === '') return;

    fetch(
      `https://collabbayadmin.com/APIControllers/GetListingByID.php?ListingID=${encodeURIComponent(
        listingID
      )}`
    )
      .then((res) => res.json())
      .then((data) => {
        const listing = Array.isArray(data) ? data[0] : data;

        if (!listing) return;

        if (listing.Location && listing.Location.trim() !== '') {
          setListingLocation(listing.Location.trim());
        } else if (listing.FullAddress && listing.FullAddress.trim() !== '') {
          setListingLocation(listing.FullAddress.trim());
        }

        if (listing.OnBehalfOf && listing.OnBehalfOf.trim() !== '') {
          setOnBehalfOf(listing.OnBehalfOf.trim());
        }
      })
      .catch((err) => console.error('Error fetching listing:', err));
  }, [listingID]);

  // Helper for opening external links in same tab (web) or via Linking (native)
  const openInSameTab = (url) => {
    if (typeof window !== 'undefined') {
      window.location.href = url;
    } else {
      Linking.openURL(url);
    }
  };


const isProposal = String(latestUpdate?.IsProposal || '').toUpperCase() === 'Y';

// MAIN RENDER
return (
    <SafeAreaView style={styles.appShell}>
      {/* QUICK TOAST — Booking Accepted */}
      {quickToast && (
        <View style={styles.quickToast}>
          <Ionicons
            name="checkmark-circle"
            size={18}
            color="black"
            style={{ marginRight: 6 }}
          />
          <Text style={styles.quickToastText}>Booking Accepted</Text>
        </View>
      )}

      <View style={styles.shellRow}>
        {/* SIDE NAVIGATION */}
        <View style={styles.sideNav}>
          <LinearGradient
            colors={['#050509', '#050505', '#000000']}
            style={styles.sideNavInner}
          >
            {/* subtle glow / blur-esque blob */}
     <LinearGradient
  colors={['rgba(253,240,93,0.08)', 'rgba(0,0,0,0)']} // very light FDF05D
  style={styles.sideNavGlow}
  start={{ x: 0.1, y: 0 }}
  end={{ x: 1, y: 1 }}
/>


            {/* TOP: Logo + wordmark */}
            <View style={styles.sideNavHeader}>
              <Image
                source={{
                  uri: 'https://collabbayadmin.com/CollabbayLogoDark.png',
                }}
                style={styles.sideNavLogoImage}
                resizeMode="contain"
              />
              <View>
                <Text style={styles.logoWordmark}>
                  <Text style={{ fontWeight: '300' }}>collab</Text>
                  bay
                  <Text style={styles.logoDot}>.</Text>
                </Text>
                <Text style={styles.logoDesktopTag}>DESKTOP</Text>
              </View>
            </View>

            {/* MAIN NAV SECTION */}
            <View style={styles.sideNavSection}>

<LinearGradient
  colors={['#111111', '#2b2b2b']} // slightly lighter-than-black gradient
  start={{ x: 0, y: 0 }}
  end={{ x: 1, y: 0 }}
  style={{
    paddingTop: 4,
    paddingBottom: 8,
    paddingHorizontal: 10,
    borderRadius: 999,        // pill shape
    alignSelf: 'flex-start',  // hug content on the left
    maxWidth: '100%',
    marginLeft: 1,
  }}
>
  <Text
    numberOfLines={1}
    ellipsizeMode="tail"
    style={{
      fontSize: 8,
      color: '#ffffff',
      textTransform: 'uppercase',
      letterSpacing: 1,
      textAlign: 'left',
    }}
  >
    {userData.Username ? ` ${userData.Username}` : 'Welcome Back'}
  </Text>
</LinearGradient>


              {/* Home → MyPanel */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => navigation.navigate('MyPanel')}
              >
                <View style={styles.navItemRow}>
                  <View style={styles.navItemMainLabel}>
                    <Ionicons
                      name="home-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>Home</Text>
                  </View>
                </View>
              </TouchableOpacity>

              {/* My Offers → MyOffers */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => navigation.navigate('MyOffers')}
              >
                <View style={styles.navItemRow}>
                  <View style={styles.navItemMainLabel}>
                    <Ionicons
                      name="pricetags-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>My Offers</Text>
                  </View>
                </View>
              </TouchableOpacity>

              {/* My Calendar → MyCalendar (LOCKED if NOT authed) */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => {
                  if (authChecked && !isAuthed) {
                    openInSameTab(
                      'https://collabbayadmin.com/subscribe'
                    );
                  } else {
                    navigation.navigate('MyCalendar');
                  }
                }}
              >
                <View style={styles.navItemRow}>
                  <View style={styles.navItemMainLabel}>
                    <Ionicons
                      name="calendar-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>My Calendar</Text>
                  </View>
                  {authChecked && !isAuthed && (
                    <Ionicons
                      name="lock-closed-outline"
                      size={16}
                      color="#FDF05D"
                      style={styles.lockIcon}
                    />
                  )}
                </View>
              </TouchableOpacity>

              {/* Browse Creators → BrowseCreators */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => navigation.navigate('BrowseCreators')}
              >
                <View style={styles.navItemRow}>
                  <View style={styles.navItemMainLabel}>
                    <Ionicons
                      name="people-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>Browse Creators</Text>
                  </View>
                </View>
              </TouchableOpacity>

              {/* Activity → MyActivityFeed (LOCKED if NOT authed) */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => {
                  if (authChecked && !isAuthed) {
                    openInSameTab(
                      'https://collabbayadmin.com/subscribe'
                    );
                  } else {
                    navigation.navigate('MyPanel');
                  }
                }}
              >
                <View style={styles.navItemRow}>
                  <View className="navItemMainLabel" style={styles.navItemMainLabel}>
                    <Ionicons
                      name="chatbubbles-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>Activity</Text>
                  </View>
                  {authChecked && !isAuthed && (
                    <Ionicons
                      name="lock-closed-outline"
                      size={16}
                      color="#FDF05D"
                      style={styles.lockIcon}
                    />
                  )}
                </View>
              </TouchableOpacity>

              {/* Account → BusinessAccountPage */}
              <TouchableOpacity
                style={styles.navItem}
                onPress={() => navigation.navigate('BusinessAccountPage')}
              >
                <View style={styles.navItemRow}>
                  <View style={styles.navItemMainLabel}>
                    <Ionicons
                      name="person-circle-outline"
                      size={20}
                      color="#f5f5f5"
                      style={styles.navIcon}
                    />
                    <Text style={styles.navText}>Account</Text>
                  </View>
                </View>
              </TouchableOpacity>
            </View>

            {/* MIDDLE SECTION: Peer Map + Subscribe CTA */}
            <View style={styles.sideNavSection}>
              {/* Peer Map */}
              <TouchableOpacity
                style={styles.peerMapCard}
                activeOpacity={0.9}
                onPress={() => openInSameTab('/venues')}
              >
                <LinearGradient
                  colors={['rgba(255,255,255,0.08)', 'rgba(0,0,0,0.4)']}
                  style={styles.peerMapInner}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                >
                  <View style={styles.peerMapContent}>
                    <Ionicons
                      name="map-outline"
                      size={18}
                      color="#FDF05D"
                      style={{ marginRight: 8 }}
                    />
                    <View style={{ flex: 1 }}>
                      <Text style={styles.peerMapTitle}>Peer Map</Text>
                      <Text style={styles.peerMapSubtitle}>
                        View 100+ venues on Collabbay
                      </Text>
                    </View>
                  </View>
                </LinearGradient>
              </TouchableOpacity>

              {/* Subscribe CTA — only show if NOT subscriber */}
              {!isSubscriber && (
                <TouchableOpacity
                  style={styles.subscribeCard}
                  activeOpacity={0.9}
                  onPress={() =>
                    openInSameTab('https://collabbayadmin.com/subscribe')
                  }
                >
                  <LinearGradient
                    colors={['#FDF05D', '#fbbf24']}
                    style={styles.subscribeGradient}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                  >
                    <View style={styles.subscribeContent}>
                      <Ionicons
                        name="rocket-outline"
                        size={20}
                        color="#000"
                        style={{ marginRight: 8 }}
                      />
                      <View style={{ flex: 1 }}>
                        <Text style={styles.subscribeTitle}>
                          Subscribe & unlock
                        </Text>
                        <Text style={styles.subscribeSubtitle}>
                          Unlock Activity & Calendar, plus more.
                        </Text>
                      </View>
                    </View>
                  </LinearGradient>
                </TouchableOpacity>
              )}
            </View>

            {/* BOTTOM: FAQ + Help */}
            <View style={styles.sideNavBottom}>
              <TouchableOpacity
                style={styles.bottomLink}
                onPress={() =>
                  openInSameTab('https://collabbayadmin.com/FAQs')
                }
              >
                <Ionicons
                  name="help-circle-outline"
                  size={18}
                  color="#f5f5f5"
                  style={{ marginRight: 8 }}
                />
                <View>
                  <Text style={styles.bottomLinkText}>FAQs</Text>
                  <Text style={styles.bottomLinkCaption}>
                    Common questions answered
                  </Text>
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.bottomLink}
                onPress={() =>
                  Linking.openURL('mailto:info@collab-bay.com')
                }
              >
                <Ionicons
                  name="headset-outline"
                  size={18}
                  color="#f5f5f5"
                  style={{ marginRight: 8 }}
                />
                <View>
                  <Text style={styles.bottomLinkText}>Help</Text>
                  <Text style={styles.bottomLinkCaption}>
                    We&apos;re here 24/7
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          </LinearGradient>
        </View>

        {/* MAIN AREA */}
        <View style={styles.mainArea}>
          {isLoading ? (
            <View style={[styles.loadingCenter, { flex: 1 }]}>
              <ActivityIndicator size="large" color="black" />
              <Text style={styles.loadingText}>Loading collab details…</Text>
            </View>
          ) : (
          <ScrollView
  ref={scrollViewRef}
  contentContainerStyle={styles.contentContainer}
  showsVerticalScrollIndicator={false}
>
              <View style={styles.pageInner}>
                <View style={styles.pageHeaderRow}>
                  <TouchableOpacity
                    style={styles.backButton}
                    onPress={handleBackPress}
                  >
                    <Ionicons name="arrow-back" size={20} color="black" />
                    <Text style={styles.backButtonText}>Back to activity</Text>
                  </TouchableOpacity>

                  <View style={styles.statusRowTop}>
                    <View
                      style={[
                        styles.statusBadgeTop,
                        getStatusStyle(getCollabStatus(latestUpdate)),
                      ]}
                    >
                      <Text style={styles.statusText}>
                        {getCollabStatus(latestUpdate)}
                      </Text>
                      {/* ✨ AI recap inline in badge */}
                      <View style={styles.statusAiRow}>
                        <Text style={styles.statusAiSparkle}>✨</Text>
                        <Text
                          style={styles.statusAiText}
                          numberOfLines={1}
                        >
                          {getAISummary()}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>

                {/* Update Modal */}
                <Modal
                  animationType="fade"
                  transparent={true}
                  visible={isUpdateModalVisible}
                  onRequestClose={() => setIsUpdateModalVisible(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                      <Ionicons
                        name={
                          isUpdateSuccessful
                            ? 'checkmark-circle-outline'
                            : 'alert-circle-outline'
                        }
                        size={48}
                        color={isUpdateSuccessful ? 'green' : 'red'}
                      />
                      <Text style={styles.modalText}>
                        {updateModalMessage}
                      </Text>
                      <TouchableOpacity
                        style={styles.modalButton}
                        onPress={() => {
                          setIsUpdateModalVisible(false);
                          if (isUpdateSuccessful) {
                            window.location.reload();
                          }
                        }}
                      >
                        <Text style={styles.modalButtonText}>Close</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </Modal>

                {/* Approve Modal (reused) */}
                <Modal
                  animationType="fade"
                  transparent={true}
                  visible={isApproveModalVisible}
                  onRequestClose={() => setIsApproveModalVisible(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                      <Ionicons
                        name={
                          isApproveSuccessful
                            ? 'checkmark-circle-outline'
                            : 'alert-circle-outline'
                        }
                        size={48}
                        color={isApproveSuccessful ? 'green' : 'red'}
                      />
                      <Text style={styles.modalText}>
                        {approveModalMessage}
                      </Text>
                      <TouchableOpacity
                        style={styles.modalButton}
                        onPress={() => setIsApproveModalVisible(false)}
                      >
                        <Text style={styles.modalButtonText}>Close</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </Modal>

                {/* HOW TO COLLAB CARD */}
                <View style={styles.howToCard}>
                  <TouchableOpacity
                    onPress={toggleHowToCollabVisibility}
                    activeOpacity={0.8}
                  >
                    <View style={styles.howToHeaderRow}>
                      <Text style={styles.howToTitle}>
                        How to collab <Text style={styles.howToDot}>•</Text>
                      </Text>
                      <Ionicons
                        name={
                          isHowToCollabVisible ? 'chevron-up' : 'chevron-down'
                        }
                        size={24}
                        color="black"
                      />
                    </View>
                  </TouchableOpacity>

                  {isHowToCollabVisible && (
                    <>
                      <View style={styles.tabSwitcherRow}>
                        <TouchableOpacity
                          style={[
                            styles.tabSwitch,
                            activeTab === 'CodeSystem' &&
                              styles.tabSwitchActive,
                          ]}
                          onPress={() => setActiveTab('CodeSystem')}
                        >
                          <Text
                            style={[
                              styles.tabSwitchText,
                              activeTab === 'CodeSystem' &&
                                styles.tabSwitchTextActive,
                            ]}
                          >
                            Using a code
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={[
                            styles.tabSwitch,
                            activeTab === 'QRSystem' && styles.tabSwitchActive,
                          ]}
                          onPress={() => setActiveTab('QRSystem')}
                        >
                          <Text
                            style={[
                              styles.tabSwitchText,
                              activeTab === 'QRSystem' &&
                                styles.tabSwitchTextActive,
                            ]}
                          >
                            Using QRs
                          </Text>
                        </TouchableOpacity>
                      </View>

                      {activeTab === 'CodeSystem' && (
                        <View style={styles.howToBody}>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>1-</Text> The
                            influencer arrives, mentioning they are with
                            collabbay.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>2-</Text>{' '}
                            Ensure staff provide the venue code to the
                            influencer when asked, yours is:{' '}
                            <Text style={styles.howToHighlight}>
                              {userData.VenueCode || 'N/A'}
                            </Text>
                            .
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>3-</Text> The
                            influencer prepares footage for their content
                            on-site.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>4-</Text> The
                            final content is due within the agreed deadline
                            after their visit.
                          </Text>
                        </View>
                      )}

                      {activeTab === 'QRSystem' && (
                        <View style={styles.howToBody}>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>1-</Text> The
                            influencer arrives, mentioning they are with
                            collabbay.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>2-</Text>{' '}
                            Provide the offer agreed for the collab.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>3-</Text> The
                            influencer prepares footage for their content
                            on-site.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>4-</Text>{' '}
                            Before the influencer leaves, scan their QR code.
                          </Text>
                          <Text style={styles.howToStepText}>
                            <Text style={styles.howToStepNumber}>5-</Text> The
                            final content is due within the agreed deadline
                            after their visit.
                          </Text>
                        </View>
                      )}
                    </>
                  )}
                </View>

                {/* PROFILE + APPROVE SECTION AS DESKTOP ROW */}
                <View style={styles.topRow}>
                  <View style={styles.profileColumn}>

<View style={{ position: 'relative', width: '100%' }}>
  {renderRevealAnimation()}
  {renderPromoterProfile()}
</View>

                    <TouchableOpacity
                      style={styles.influencerProfileButton}
                      onPress={() =>
                        navigation.navigate('CreatorOverview', {
                          PlatformUsername: platformUsername,
                        })
                      }
                    >
                      <Text style={styles.influencerProfileButtonText}>
                        View Influencer Profile
                      </Text>
                      <Ionicons
                        name="arrow-forward"
                        size={20}
                        color="black"
                      />
                    </TouchableOpacity>

                    <View style={styles.contactCreatorCard}>
                      <TouchableOpacity
                        style={styles.contactCreatorButton}
                        onPress={() => {
                          if (promoterEmail) {
                            Linking.canOpenURL(`mailto:${promoterEmail}`)
                              .then((supported) => {
                                if (supported) {
                                  Linking.openURL(`mailto:${promoterEmail}`);
                                } else {
                                  alert(
                                    'Email service is not available on this device. Contact the creator via social media.'
                                  );
                                }
                              })
                              .catch((error) =>
                                console.error(
                                  'Error opening mail client:',
                                  error
                                )
                              );
                          } else {
                            alert('No email address available.');
                          }
                        }}
                      >
                        <Ionicons
                          name="mail-outline"
                          size={24}
                          color="black"
                          style={styles.contactIcon}
                        />
                        <Text style={styles.contactButtonText}>
                          Contact Creator
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={styles.copyEmailButton}
                        onPress={handleCopyEmail}
                      >
                        <Ionicons
                          name={
                            isEmailCopied ? 'checkmark-outline' : 'copy-outline'
                          }
                          size={20}
                          color="black"
                          style={styles.copyEmailIcon}
                        />
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={styles.copyEmailButton}
                        onPress={handleShareCopy}
                      >
                        <FontAwesome name="share" size={20} color="black" />
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={styles.copyEmailButton}
                        onPress={() => setIsChatModalVisible(true)}
                      >
                        <Ionicons
                          name="chatbox-ellipses-outline"
                          size={20}
                          color="black"
                          style={styles.copyEmailIcon}
                        />
                      </TouchableOpacity>
                    </View>

                    {isEmailCopied && (
                      <Text style={styles.copiedText}>Email copied</Text>
                    )}

                    {shareCopied && (
                      <View style={styles.toastCard}>
                        <Ionicons
                          name="checkmark-circle"
                          size={16}
                          color="white"
                          style={{ marginRight: 5 }}
                        />
                        <Text style={styles.toastText}>Recap copied</Text>
                      </View>
                    )}

                    {renderRedeemStatus()}
                  </View>

                  <View style={styles.statusColumn}>
                    {/* Approve / Move CTA */}
                    {getCollabStatus(latestUpdate) === 'Expired' ? (
                      <View style={styles.approveButtonContainer}>
                        <TouchableOpacity
                          style={styles.approveButton}
                          activeOpacity={0.85}
                          onPress={() => {
                            const futureDate = new Date();
                            futureDate.setDate(futureDate.getDate() + 10);
                            futureDate.setHours(17, 0, 0, 0);
                            setSelectedDate(futureDate.toDateString());
                            setSelectedTime('5:00 PM');
                            setIsMoveModalVisible(true);
                          }}
                        >
                          <Ionicons
                            name="calendar-outline"
                            size={18}
                            color="black"
                            style={{ marginRight: 5 }}
                          />
                          <Text style={styles.approveButtonInnerText}>
                            Missed this? Propose new date
                          </Text>
                        </TouchableOpacity>
                      </View>
                    ) : (
    latestUpdate.Status === 'Pending' &&
userData.Username &&
latestUpdate.LastUpdateFrom !== userData.Username && (
  <View style={styles.approveButtonContainer}>
    {isProposal ? (
   <TouchableOpacity
  style={[styles.approveButton, styles.proposalAcceptButton]}
  onPress={handleAcceptProposal}
>
  <View style={{ alignItems: 'center' }}>
    <Text style={[styles.approveButtonLabel, styles.proposalAcceptButtonLabel]}>
      <Ionicons
        name="checkmark-circle"
        size={20}
        color="#fff"
      />{' '}
      Accept Proposal
    </Text>
  </View>
</TouchableOpacity>
    ) : (
      <TouchableOpacity
        style={styles.approveButton}
        onPress={handleApproveCollab}
      >
        <View style={{ alignItems: 'center' }}>
          <Text style={styles.approveButtonLabel}>
            <Ionicons
              name="checkmark-circle"
              size={20}
              color="black"
            />{' '}
            Approve Collab
          </Text>

          {accountAdmin && (
            <View style={{ marginTop: 8 }}>
              {accountAdmin
                .split(',')
                .map((admin, index) => (
                  <Text
                    key={index}
                    style={styles.accountAdminText}
                  >
                    <Ionicons
                      name="mail-outline"
                      size={10}
                      color="black"
                    />{' '}
                    {admin.trim()}
                  </Text>
                ))}
            </View>
          )}
        </View>
      </TouchableOpacity>
    )}
  </View>
)
                    )}

                    {/* Collab Status Card */}
{isProposal && (
  <View style={styles.proposalInfoCard}>
    <View style={styles.proposalHeaderRow}>
      <View style={styles.proposalIconCircle}>
        <Ionicons name="information-circle" size={18} color="#2563eb" />
      </View>

      <View style={{ flex: 1 }}>
        <View style={styles.proposalBadgeRow}>
          <View style={styles.proposalTextBadge}>
            <Text style={styles.proposalTextBadgeLabel}>Proposal</Text>
          </View>

          <View style={styles.proposalSubBadge}>
            <Text style={styles.proposalSubBadgeLabel}>
              Curated by collabbay™ 
            </Text>
          </View>
        </View>

        <Text style={styles.proposalInfoTitle}>
          This is a hand-picked proposal.
        </Text>
      </View>
    </View>

    <Text style={styles.proposalInfoBody}>
      Our agents matched this creator and booking slot to you. If you accept this proposal, the creator will also need to accept it before the booking is confirmed. You can amend the date or time as needed, and communicate with the creator to confirm a slot.
    </Text>

    <TouchableOpacity
  style={styles.proposalAmendChip}
  onPress={handleJumpToMoveOptions}
  activeOpacity={0.85}
>
  <Ionicons
    name="calendar-outline"
    size={15}
    color="#2563eb"
    style={{ marginRight: 6 }}
  />

  <Text style={styles.proposalAmendChipText}>
    Amend proposed date?
  </Text>

  <Ionicons
    name="arrow-down-outline"
    size={14}
    color="#2563eb"
    style={{ marginLeft: 6 }}
  />
</TouchableOpacity>
  </View>
)}

{/* Collab Status Card */}
<View style={styles.statusCard}>
                      <View style={styles.statusTitleContainer}>
                        <Text style={styles.subheader}>Collab Status</Text>

                        {latestUpdate.LastUpdateFrom &&
                          latestUpdate.LastUpdateFrom ===
                            userData.Username &&
                          latestUpdate.Status === 'Pending' && (
                            <View style={styles.pendingWithChip}>
                              <Ionicons
                                name="alert-circle"
                                size={20}
                                color="black"
                                style={{ marginRight: 8 }}
                              />
                              <Text style={styles.pendingWithText}>
                                Pending with {promoterName || 'Promoter'}
                              </Text>
                            </View>
                          )}
                      </View>

                      {onBehalfOf && (
                        <View style={styles.onBehalfOfChip}>
                          <Text style={styles.onBehalfOfLabel}>Client |</Text>
                          <Text style={styles.onBehalfOfValue}>
                            {onBehalfOf}
                          </Text>
                          <Ionicons
                            name="person-circle-outline"
                            size={18}
                            color="#555"
                            style={{ marginLeft: 6 }}
                          />
                        </View>
                      )}

                      <Text style={styles.statusLabel}>
                        Proposed Booking Date:{' '}
                        {latestUpdate.CreditAvailableStart}
                      </Text>

                      {listingLocation !== '' && (
                        <View style={styles.locationChip}>
                          <Text style={styles.locationText}>
                            📍 {listingLocation}
                          </Text>
                        </View>
                      )}

                      <Text style={styles.statusLabel}>
                        Status:{' '}
                        {latestUpdate.Status === 'Pending'
                          ? 'Booking not yet confirmed. Pending approval.'
                          : latestUpdate.Status || 'Pending'}
                      </Text>

                      {/* ✨ Simple AI Recap inside status card */}
                      <View style={styles.aiInlineRow}>
                        <Text style={styles.aiInlineSparkle}>✨</Text>
                        <Text style={styles.aiInlineText}>
                          {getAISummary()}
                        </Text>
                      </View>

                      <Text style={styles.statusLabel}>
                        Added Visitors (Plus-ones):{' '}
                        {latestUpdate.AddedVisitors || 'None'}{' '}
                        <TouchableOpacity
                          onPress={() => setIsCancelModalVisible(true)}
                        >
                          <Ionicons
                            name="help-circle-outline"
                            size={20}
                            color="darkgrey"
                            style={{ marginLeft: 5 }}
                          />
                        </TouchableOpacity>
                      </Text>

                      {latestUpdate.CreatorFirstName ? (
                        <>
                          <Text style={styles.subheader}>Creator Details</Text>
                          <Text style={styles.statusLabel}>
                            First Name: {latestUpdate.CreatorFirstName}
                          </Text>
                        </>
                      ) : null}

                      {latestUpdate.CreatorLastName ? (
                        <Text style={styles.statusLabel}>
                          Last Name: {latestUpdate.CreatorLastName}
                        </Text>
                      ) : null}

                      {latestUpdate.CreatorPhoneNumber ? (
                        <Text style={styles.statusLabel}>
                          Mobile: {latestUpdate.CreatorPhoneNumber}
                        </Text>
                      ) : null}

                      {/* Chat preview inside card */}
                      <View style={styles.chatContainer}>
                        <View style={styles.chatHeader}>
                          <Ionicons
                            name="chatbox-outline"
                            size={20}
                            color="black"
                          />
                          <Text style={styles.chatHeaderText}>Messages</Text>
                        </View>

                        {chatMessages.map((msg, index) => (
                          <View
                            key={index}
                            style={[
                              styles.chatBubble,
                              msg.user === userData.Username
                                ? styles.sentMessage
                                : styles.receivedMessage,
                            ]}
                          >
                            <Text style={styles.chatUser}>{msg.user}</Text>
                            <Text style={styles.chatText}>{msg.text}</Text>
                          </View>
                        ))}
                      </View>

                      {isCancelModalVisible && (
                        <View style={styles.inlineInfoOverlay}>
                          <View style={styles.inlineInfoCard}>
                            <Text style={styles.inlineInfoText}>
                              Via Collabbay, only the influencer who booked this
                              offer will be required to deliver content to you.
                              Their plus-ones are managed at your discretion.
                            </Text>
                            <TouchableOpacity
                              onPress={() => setIsCancelModalVisible(false)}
                              style={styles.inlineInfoButton}
                            >
                              <Text style={styles.inlineInfoButtonText}>
                                Close
                              </Text>
                            </TouchableOpacity>
                          </View>
                        </View>
                      )}
                    </View>
                  </View>
                </View>

             {/* MOVE / CANCEL BOOKING SECTION */}
<TouchableOpacity
  nativeID="moveCancelSection"
  style={styles.header}
  onPress={handleToggleExpand}
>
                  <Text style={styles.updateToggleText}>
                    Move or cancel booking?{' '}
                    <Ionicons
                      name={isExpanded ? 'chevron-up' : 'chevron-down'}
                      size={20}
                      color="black"
                    />
                  </Text>
                </TouchableOpacity>

                {isExpanded && (
                  <View
                    style={[styles.updateCollabCard, styles.centeredContainer]}
                  >
                    {renderDatePicker()}
                    {renderTimePicker()}
                    <TextInput
                      style={styles.textInput}
                      placeholder="Add a message..."
                      placeholderTextColor="gray"
                      value={message}
                      onChangeText={setMessage}
                      multiline={true}
                      maxLength={400}
                    />
                    <Text style={styles.charCounter}>
                      {message.length} / 400
                    </Text>
                    <TouchableOpacity
                      style={styles.button}
                      onPress={handleSubmit}
                    >
                      <Text style={styles.buttonText}>Propose Update</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[styles.button, { backgroundColor: 'white' }]}
                      onPress={toggleCancelModal}
                    >
                      <Ionicons
                        name="warning-outline"
                        size={20}
                        color="red"
                      />
                      <Text style={styles.cancelCtaText}>Need to Cancel?</Text>
                    </TouchableOpacity>

                    {isCancelModalVisible && (
                      <View style={styles.cancelModal}>
                        <View style={styles.cancelModalContent}>
                          <TouchableOpacity
                            style={styles.closeButton}
                            onPress={toggleCancelModal}
                          >
                            <Ionicons
                              name="close-circle-outline"
                              size={24}
                              color="black"
                            />
                          </TouchableOpacity>
                          <Text style={styles.cancelModalTitle}>
                            Are you sure you want to cancel?
                          </Text>
                          <Text style={styles.cancelModalSubtitle}>
                            Add a message (required):
                          </Text>
                          <TextInput
                            style={styles.textInput}
                            placeholder="Enter a message..."
                            placeholderTextColor="gray"
                            value={cancelMessage}
                            onChangeText={setCancelMessage}
                            multiline={true}
                            maxLength={400}
                          />
                          <Text style={styles.charCounter}>
                            {cancelMessage.length} / 400
                          </Text>

                          <View style={styles.cancelModalButtons}>
                            <TouchableOpacity
                              style={{ padding: 10 }}
                              onPress={handleCancelBooking}
                            >
                              <Text style={styles.cancelModalConfirmText}>
                                Yes, Cancel Booking
                              </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                              style={styles.cancelModalBackButton}
                              onPress={toggleCancelModal}
                            >
                              <Text style={styles.cancelModalBackText}>
                                No, Go Back
                              </Text>
                            </TouchableOpacity>
                          </View>
                        </View>
                      </View>
                    )}
                  </View>
                )}

                {/* CANCEL SUCCESS MODAL */}
                <Modal
                  animationType="fade"
                  transparent={true}
                  visible={isCancelSuccessModalVisible}
                  onRequestClose={() => setIsCancelSuccessModalVisible(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                      <Ionicons
                        name="checkmark-circle-outline"
                        size={48}
                        color="green"
                      />
                      <Text style={styles.modalText}>
                        {cancelSuccessMessage}
                      </Text>
                      <TouchableOpacity
                        style={styles.modalButton}
                        onPress={() => {
                          setIsCancelSuccessModalVisible(false);
                          window.location.reload();
                        }}
                      >
                        <Text style={styles.modalButtonText}>Close</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </Modal>

                {/* MEDIA CONTENT */}
                {renderMediaContent()}
              </View>
            </ScrollView>
          )}
        </View>
      </View>

      {/* CHAT MODAL */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isChatModalVisible}
        onRequestClose={() => setIsChatModalVisible(false)}
      >
        <View style={styles.chatModalOverlay}>
          <View style={styles.chatModalContainer}>
            <View style={styles.chatHeaderSection}>
              <Ionicons name="chatbox-outline" size={24} color="black" />
              <Text style={styles.chatHeaderTitle}>
                Chat with {promoterName || 'User'}
              </Text>
              <TouchableOpacity
                onPress={() => setIsChatModalVisible(false)}
                style={styles.chatCloseButton}
              >
                <Ionicons name="close" size={24} color="black" />
              </TouchableOpacity>
            </View>

            <ScrollView style={styles.chatMessagesSection}>
              {chatMessages.map((msg, index) => (
                <View
                  key={index}
                  style={[
                    styles.chatBubble,
                    msg.user === userData.Username
                      ? styles.sentMessage
                      : styles.receivedMessage,
                  ]}
                >
                  <Text style={styles.chatUser}>{msg.user}</Text>
                  <Text style={styles.chatText}>{msg.text}</Text>
                </View>
              ))}
            </ScrollView>

            {sendSuccess && (
              <View style={{ alignItems: 'center', marginVertical: 10 }}>
                <Ionicons name="checkmark-circle" size={32} color="green" />
                <Text style={{ color: 'green', marginTop: 5 }}>
                  Message sent
                </Text>
              </View>
            )}

            <View style={styles.chatInputSection}>
              <TextInput
                placeholder="Type your message..."
                placeholderTextColor="#888"
                style={styles.chatTextInput}
                value={newChatMessage}
                onChangeText={setNewChatMessage}
                multiline={true}
                maxLength={400}
              />
              <Text style={styles.charCounter}>
                {newChatMessage.length} / 400
              </Text>
              <TouchableOpacity
                style={styles.sendButton}
                onPress={handleSendChatMessage}
                disabled={isChatSending}
              >
                <Ionicons name="send" size={24} color="black" />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* MOVE DATE MODAL */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={isMoveModalVisible}
        onRequestClose={() => setIsMoveModalVisible(false)}
      >
        <View style={styles.moveModalOverlay}>
          <View style={styles.moveModalContent}>
            <TouchableOpacity
              style={styles.moveModalClose}
              onPress={() => setIsMoveModalVisible(false)}
            >
              <Ionicons name="close" size={22} color="black" />
            </TouchableOpacity>

            <Text style={styles.moveModalTitle}>Propose New Booking Date</Text>

            <ScrollView
              contentContainerStyle={{ alignItems: 'center' }}
              style={{ width: '100%' }}
              showsVerticalScrollIndicator={false}
            >
              <View style={styles.modalPickerWrapper}>
                {renderDatePicker()}
                {renderTimePicker()}
              </View>

              <TouchableOpacity
                style={styles.moveModalConfirmButton}
                onPress={() => {
                  const fullDateTime = `${selectedDate} ${selectedTime}`;
                  fetch(
                    `https://collabbayadmin.com/APIControllers/AdminUpdateCollab.php?CollabID=${CollabID}`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        CreditAvailableStart: fullDateTime,
                        Message: '',
                      }),
                    }
                  )
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        Alert.alert(
                          '✅ Success',
                          'Booking date updated successfully!'
                        );
                        setIsMoveModalVisible(false);
                        window.location.reload();
                      } else {
                        Alert.alert(
                          '⚠️ Error',
                          data.message || 'Failed to update booking.'
                        );
                      }
                    })
                    .catch((err) => {
                      console.error(err);
                      Alert.alert('Error', 'Network issue, please retry.');
                    });
                }}
              >
                <Text style={styles.moveModalConfirmText}>
                  Propose New Date
                </Text>
              </TouchableOpacity>
            </ScrollView>
          </View>
        </View>
      </Modal>

      {/* ✅ Reward Delight Success Modal */}
      <Modal transparent visible={showSuccessModal} animationType="fade">
        <View style={styles.modalOverlayReward}>
          <Animated.View
            style={[
              styles.modalCardReward,
              { transform: [{ scale: scaleAnim }] },
            ]}
          >
            <View style={styles.tickCircleReward}>
              <Ionicons name="checkmark" size={40} color="#fff" />
            </View>

            <Text style={styles.mainTitleReward}>
              Collab Booking Confirmed
            </Text>

            <Text style={styles.subTextReward}>
              Congrats — you just saved some serious time.
            </Text>

            <View style={styles.infoCardReward}>
              <Text style={styles.infoTextReward}>
                💡 On average, arranging a collab manually (without us) would
                take 1.2 weeks of back-and-forth, 4+ emails, 5+ DMs, and 1
                manual booking.{'\n\n'}
                This took you just 1 click, and{' '}
                <Text style={{ fontWeight: 'bold' }}>
                  {acceptDuration} seconds{' '}
                </Text>
                (yes, we timed it!)
              </Text>
            </View>

            <Text style={styles.footerTextReward}>
              Now go run your business — we’ll handle reminders, follow-ups and
              secure tracking for you.
            </Text>

            <TouchableOpacity
              style={styles.buttonReward}
              onPress={() => {
                setShowSuccessModal(false);
                navigation.navigate('BrowseInviteCreators');
              }}
            >
              <Text style={styles.buttonTextReward}>Continue</Text>
            </TouchableOpacity>
          </Animated.View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  // APP SHELL
  appShell: {
    flex: 1,
    backgroundColor: '#f3f3f3',
  },
  loadingCenter: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 10,
    color: '#555',
    fontSize: 14,
  },
  shellRow: {
    flex: 1,
    flexDirection: 'row',
  },

  // SIDE NAV
  sideNav: {
    width: 250,
    backgroundColor: '#000',
  },
  sideNavInner: {
    flex: 1,
    paddingVertical: 24,
    paddingHorizontal: 16,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    overflow: 'hidden',
    position: 'relative',
  },

  sideNavGlow: {
  position: 'absolute',
  top: 140,
  left: -60,
  width: 260,
  height: 260,
  borderRadius: 130,
  opacity: 0.55, // still subtle because the color alpha is 0.08
},

  sideNavHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 26,
    zIndex: 2,
  },
  sideNavLogoImage: {
    width: 38,
    height: 38,
    marginRight: 10,
  },
  logoWordmark: {
    fontSize: 16,
    color: '#f5f5f5',
    fontWeight: '600',
    letterSpacing: 0.3,
  },
  logoDot: {
    color: '#FDF05D',
    fontSize: 18,
    fontWeight: '800',
  },
  logoDesktopTag: {
    fontSize: 9,
    color: '#b3b3b3',
    letterSpacing: 2,
    marginTop: 2,
  },
  sideNavSection: {
    marginTop: 12,
    marginBottom: 20,
    zIndex: 2,
  },
  sideNavSectionLabel: {
    fontSize: 11,
    textTransform: 'uppercase',
    color: '#8c8c8c',
    marginBottom: 8,
    letterSpacing: 1,
  },
  navItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 9,
    paddingHorizontal: 8,
    borderRadius: 10,
    marginBottom: 6,
  },
  navIcon: {
    marginRight: 10,
  },
  navItemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  navItemMainLabel: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  navText: {
    color: '#f5f5f5',
    fontSize: 14,
    fontWeight: '500',
  },
  lockIcon: {
    marginLeft: 6,
  },

  // Peer Map card
  peerMapCard: {
    borderRadius: 14,
    overflow: 'hidden',
    marginTop: 4,
    marginBottom: 10,
  },
  peerMapInner: {
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
  },
  peerMapContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  peerMapTitle: {
    color: '#f5f5f5',
    fontSize: 13,
    fontWeight: '600',
  },
  peerMapSubtitle: {
    color: '#b3b3b3',
    fontSize: 11,
    marginTop: 2,
  },

  // Subscribe CTA
  subscribeCard: {
    borderRadius: 14,
    overflow: 'hidden',
    marginTop: 10,
  },
  subscribeGradient: {
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  subscribeContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  subscribeTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#000',
  },
  subscribeSubtitle: {
    fontSize: 11,
    color: '#1f2933',
    marginTop: 2,
  },

  // BOTTOM LINKS
  sideNavBottom: {
    marginTop: 'auto',
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#181818',
    zIndex: 2,
  },
  bottomLink: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
  },
  bottomLinkText: {
    fontSize: 13,
    color: '#f5f5f5',
    fontWeight: '600',
  },
  bottomLinkCaption: {
    fontSize: 11,
    color: '#b3b3b3',
    marginTop: 2,
  },

  // MAIN AREA
  mainArea: {
    flex: 1,
    backgroundColor: '#f3f3f3',
  },
  contentContainer: {
    paddingHorizontal: 24,
    paddingVertical: 24,
  },
  pageInner: {
    width: '100%',
    maxWidth: 1100,
    alignSelf: 'center',
  },

  // HEADER + STATUS
  pageHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 999,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 2,
    elevation: 2,
  },
  backButtonText: {
    marginLeft: 6,
    fontSize: 13,
    color: '#333',
    fontWeight: '500',
  },

  statusRowTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  statusBadgeTop: {
    borderRadius: 7,
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: '#e3e3e3',
    maxWidth: 420,
  },
  statusText: {
    color: 'black',
    fontWeight: 'bold',
    padding: 7,
    fontSize: 14,
  },
  statusAiRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
  },
  statusAiSparkle: {
    fontSize: 13,
    marginRight: 4,
  },
  statusAiText: {
    fontSize: 11,
    color: '#333',
    flex: 1,
  },

  // HOW TO CARD
  howToCard: {
    backgroundColor: '#f2f2ee',
    borderRadius: 16,
    padding: 16,
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 5,
    elevation: 3,
    marginBottom: 18,
  },
  howToHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  howToTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'black',
  },
  howToDot: {
    fontWeight: 'bold',
    color: '#FDF05D',
  },
  tabSwitcherRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 12,
    marginBottom: 12,
  },
  tabSwitch: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
    borderBottomWidth: 2,
    borderColor: '#ccc',
  },
  tabSwitchActive: {
    borderColor: 'black',
  },
  tabSwitchText: {
    color: '#777',
    fontWeight: '600',
    fontSize: 13,
  },
  tabSwitchTextActive: {
    color: 'black',
  },
  howToBody: {
    marginTop: 8,
  },
  howToStepText: {
    fontSize: 14,
    color: '#555',
    marginVertical: 5,
    lineHeight: 22,
  },
  howToStepNumber: {
    fontWeight: 'bold',
    color: '#000',
  },
  howToHighlight: {
    fontWeight: 'bold',
    color: '#000',
  },

  // TOP ROW: PROFILE + STATUS
  topRow: {
    flexDirection: 'row',
    marginTop: 12,
    marginBottom: 20,
  },
  profileColumn: {
    width: '34%',
    marginRight: 14,
  },
  statusColumn: {
    flex: 1,
    marginLeft: 6,
  },

  // PROFILE CARD
  profileCard: {
    backgroundColor: '#F1F1F1',
    padding: 16,
    borderRadius: 18,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 3,
    marginBottom: 16,
  },
  profileImage: {
    width: 180,
    height: 180,
    borderRadius: 60,
    marginBottom: 10,
  },
  profileUsername: {
    fontSize: 26,
    fontWeight: 'bold',
    color: 'black',
    marginBottom: 4,
  },
  profileFollowers: {
    fontSize: 23,
    color: 'gray',
    marginBottom: 8,
  },
  profileLinkButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fdf05d',
    paddingHorizontal: 12,
    paddingVertical: 7,
    borderRadius: 999,
    marginTop: 4,
  },
  profileLinkText: {
    marginLeft: 6,
    fontSize: 13,
    color: '#000',
    fontWeight: '500',
  },

  influencerProfileButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#D0D0D0',
    borderRadius: 999,
    paddingVertical: 10,
    marginVertical: 6,
    paddingHorizontal: 18,
    alignSelf: 'flex-start',
  },
  influencerProfileButtonText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'black',
    marginRight: 8,
  },

  // CONTACT / SHARE / CHAT
  contactCreatorCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 8,
    marginTop: 8,
    borderRadius: 12,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#eee',
  },
  contactCreatorButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 12,
    flex: 1,
    borderWidth: 1,
    borderColor: '#f3f3f3',
  },
  copyEmailButton: {
    backgroundColor: '#f3f3f3',
    borderRadius: 12,
    padding: 8,
    marginLeft: 6,
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#f3f3f3',
  },
  contactIcon: {
    marginRight: 8,
  },
  contactButtonText: {
    fontSize: 13,
    fontWeight: 'bold',
    color: 'black',
  },
  copyEmailIcon: {
    alignSelf: 'center',
  },
  copiedText: {
    marginTop: 6,
    fontSize: 12,
    color: '#fff',
    fontWeight: '600',
    textAlign: 'center',
    backgroundColor: '#28a745',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 6,
    alignSelf: 'flex-start',
  },

  toastCard: {
    position: 'absolute',
    top: 0,
    right: 0,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 10,
    backgroundColor: '#28a745',
    borderRadius: 8,
    zIndex: 999,
    elevation: 3,
  },
  toastText: {
    color: 'white',
    fontSize: 12,
    fontWeight: '600',
  },

  // STATUS CARD
  statusCard: {
    backgroundColor: '#f3f3f3',
    padding: 16,
    marginVertical: 6,
    elevation: 2,
    shadowColor: 'black',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    borderRadius: 20,
  },
  subheader: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 4,
    color: 'black',
  },
  statusTitleContainer: {
    marginBottom: 6,
  },
  pendingWithChip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fdf05d',
    borderRadius: 19,
    paddingVertical: 6,
    paddingHorizontal: 12,
    marginTop: 8,
    alignSelf: 'flex-start',
  },
  pendingWithText: {
    fontSize: 14,
    color: 'black',
    fontWeight: '500',
  },

  onBehalfOfChip: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    marginTop: 6,
    marginBottom: 7,
    backgroundColor: '#fff',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: '#ccc',
  },
  onBehalfOfLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#333',
    marginRight: 5,
  },
  onBehalfOfValue: {
    fontSize: 16,
    color: '#333',
    fontWeight: '600',
  },

  statusLabel: {
    fontSize: 14,
    marginBottom: 8,
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 16,
    color: 'black',
  },

  locationChip: {
    marginTop: 4,
    alignSelf: 'flex-start',
    backgroundColor: '#f3f3f3',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 15,
    marginLeft: 4,
    borderWidth: 1,
    marginBottom: 12,
    borderColor: '#bcbcbc',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
  },
  locationText: {
    fontSize: 15,
    color: '#444',
  },

  // ✨ AI INLINE
  aiInlineRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: 14,
    paddingHorizontal: 10,
    paddingVertical: 8,
    marginBottom: 8,
  },
  aiInlineSparkle: {
    fontSize: 16,
    marginRight: 6,
  },
  aiInlineText: {
    flex: 1,
    fontSize: 13,
    color: '#333',
  },

  // APPROVE BUTTON
  approveButton: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#74dc8a',
    borderRadius: 999,
    paddingVertical: 10,
    paddingHorizontal: 14,
    marginBottom: 7,
    minWidth: 200,
    flexDirection: 'row',
  },
  approveButtonContainer: {
    alignItems: 'flex-end',
    marginBottom: 10,
  },
  approveButtonInnerText: {
    fontWeight: 'bold',
    color: 'black',
    fontSize: 12,
    textAlign: 'center',
  },
  approveButtonLabel: {
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'black',
    fontSize: 14,
  },
  accountAdminText: {
    fontSize: 9,
    color: 'black',
    textAlign: 'center',
  },

  // STATUS STYLES
  expiredStatus: {
    backgroundColor: 'grey',
  },
  redeemedStatus: {
    backgroundColor: 'green',
  },
  upcomingStatus: {
    backgroundColor: 'lightgreen',
  },
  pendingStatus: {
    backgroundColor: 'yellow',
  },
  cancelledStatus: {
    backgroundColor: 'red',
  },

  // DATE / TIME PICKERS
  datePickerContainer: {
    marginBottom: 18,
  },
  datePickerLabel: {
    fontSize: 14,
    marginBottom: 6,
    color: 'black',
    fontWeight: 'bold',
  },
  dateOption: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginRight: 8,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: 'black',
  },
  dateOptionText: {
    fontSize: 13,
    color: 'black',
  },
  timePickerContainer: {
    marginBottom: 10,
    width: '100%',
  },
  timePickerLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 8,
    color: 'black',
  },
  timeScrollView: {
    height: 120,
  },
  timeSlot: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderColor: '#eee',
  },
  selectedTimeSlot: {
    backgroundColor: '#FDF05D',
  },

  // UPDATE / CANCEL CARD
  header: {
    marginTop: 4,
  },
  updateToggleText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'black',
    marginVertical: 8,
    textAlign: 'center',
    backgroundColor: '#e9e9e9',
    borderRadius: 10,
    paddingVertical: 8,
  },
  updateCollabCard: {
    backgroundColor: '#fff',
    borderRadius: 15,
    padding: 16,
    marginVertical: 12,
    width: '100%',
  },
  centeredContainer: {
    alignSelf: 'center',
  },

  textInput: {
    borderWidth: 1,
    borderColor: 'black',
    borderRadius: 8,
    padding: 8,
    marginTop: 6,
    marginBottom: 8,
    fontSize: 14,
    color: 'black',
    minHeight: 60,
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
    borderRadius: 999,
    paddingVertical: 10,
    marginTop: 4,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'white',
  },
  cancelCtaText: {
    color: 'red',
    textAlign: 'center',
    marginLeft: 6,
    fontWeight: '600',
  },

  charCounter: {
    marginTop: 4,
    marginBottom: 8,
    fontSize: 11,
    color: 'gray',
    textAlign: 'right',
  },

  // INLINE INFO MODAL
  inlineInfoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inlineInfoCard: {
    backgroundColor: 'white',
    padding: 18,
    borderRadius: 8,
    alignItems: 'center',
    width: '80%',
  },
  inlineInfoText: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 12,
    color: '#333',
  },
  inlineInfoButton: {
    backgroundColor: 'black',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 20,
  },
  inlineInfoButtonText: {
    color: 'white',
    fontSize: 14,
  },

  // CANCEL MODAL
  cancelModal: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cancelModalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    width: '90%',
    alignItems: 'center',
    shadowOpacity: 0.2,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 5,
    elevation: 5,
  },
  cancelModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#333',
    textAlign: 'center',
  },
  cancelModalSubtitle: {
    fontSize: 14,
    marginBottom: 10,
    color: '#666',
    textAlign: 'center',
  },
  cancelModalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 12,
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  cancelModalConfirmText: {
    color: 'black',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  cancelModalBackButton: {
    backgroundColor: '#FDF05D',
    padding: 10,
    borderRadius: 20,
  },
  cancelModalBackText: {
    color: 'black',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'bold',
  },

  // REDEEM STATUS
  redeemedContainer: {
    paddingVertical: 10,
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  redeemedText: {
    fontSize: 14,
    color: '#000',
    textAlign: 'left',
  },

  // MEDIA CONTENT
  mediaContentSection: {
    marginTop: 16,
    paddingHorizontal: 0,
  },
  mediaItemContainer: {
    marginBottom: 24,
    borderRadius: 20,
    backgroundColor: 'white',
    padding: 16,
    elevation: 2,
    shadowColor: 'black',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
  },
  mediaImage: {
    width: '100%',
    height: 400,
    borderRadius: 20,
    marginBottom: 16,
  },
  mediaContentTextSection: {
    padding: 16,
    borderRadius: 20,
    backgroundColor: '#f3f3f3',
    textAlign: 'center',
  },
  linkButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  linkIcon: {
    marginRight: 5,
  },
  mediaLinkText: {
    fontSize: 16,
    color: 'black',
    fontWeight: 'bold',
  },
  mediaMessageText: {
    fontSize: 15,
    color: 'black',
    textAlign: 'center',
  },
  downloadButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 12,
  },
  downloadText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'black',
    marginLeft: 5,
  },

  // MODAL BASE
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    width: '80%',
    padding: 20,
    backgroundColor: 'white',
    borderRadius: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 5,
    elevation: 5,
  },
  modalText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginVertical: 10,
    textAlign: 'center',
    color: '#333',
  },
  modalButton: {
    marginTop: 15,
    backgroundColor: '#FDF05D',
    padding: 10,
    borderRadius: 5,
    width: '80%',
    alignItems: 'center',
  },
  modalButtonText: {
    fontSize: 15,
    fontWeight: 'bold',
    color: 'black',
  },

  // CHAT INLINE PREVIEW
  chatContainer: {
    marginVertical: 10,
    borderRadius: 10,
    backgroundColor: '#fff',
    padding: 10,
  },
  chatHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    borderBottomWidth: 1,
    borderColor: '#ddd',
    paddingBottom: 5,
  },
  chatHeaderText: {
    fontSize: 15,
    fontWeight: 'bold',
    color: 'black',
    marginLeft: 5,
  },
  chatBubble: {
    padding: 8,
    marginVertical: 4,
    borderRadius: 10,
    maxWidth: '75%',
  },
  sentMessage: {
    backgroundColor: '#FDF05D',
    alignSelf: 'flex-end',
    borderTopRightRadius: 0,
  },
  receivedMessage: {
    backgroundColor: '#ffffff',
    alignSelf: 'flex-start',
    borderTopLeftRadius: 0,
  },
  chatUser: {
    fontSize: 10,
    color: '#555',
    marginBottom: 3,
  },
  chatText: {
    fontSize: 13,
    color: '#000',
  },

  // REVEAL OVERLAY
  revealOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    zIndex: 999,
  },
  revealCard: {
    width: 200,
    height: 235,
    backgroundColor: '#d9d9d9',
    borderRadius: 20,
    elevation: 10,
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 8,
  },

  // CHAT MODAL
  chatModalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  chatModalContainer: {
    backgroundColor: '#f3f3f3',
    width: '90%',
    maxWidth: 600,
    height: '80%',
    borderRadius: 15,
    padding: 10,
    justifyContent: 'space-between',
  },
  chatHeaderSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    paddingHorizontal: 15,
    backgroundColor: '#fff',
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },
  chatHeaderTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'black',
    flex: 1,
    marginLeft: 10,
  },
  chatCloseButton: {
    padding: 5,
  },
  chatMessagesSection: {
    flex: 1,
    padding: 10,
  },
  chatInputSection: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderBottomLeftRadius: 15,
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    borderBottomRightRadius: 15,
  },
  chatTextInput: {
    flex: 1,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#ccc',
    paddingHorizontal: 15,
    paddingVertical: 8,
    marginRight: 10,
    backgroundColor: '#fff',
    fontSize: 14,
    color: 'black',
  },
  sendButton: {
    borderRadius: 20,
    padding: 10,
  },

  // MOVE MODAL
  moveModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  moveModalContent: {
    width: '90%',
    maxWidth: 450,
    maxHeight: 500,
    backgroundColor: 'white',
    borderRadius: 15,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 5,
    elevation: 10,
  },
  moveModalClose: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 8,
  },
  moveModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'black',
    marginBottom: 15,
    textAlign: 'center',
  },
  modalPickerWrapper: {
    width: '100%',
    alignItems: 'center',
    overflow: 'hidden',
  },
  moveModalConfirmButton: {
    backgroundColor: 'black',
    borderRadius: 25,
    paddingVertical: 12,
    paddingHorizontal: 30,
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 10,
  },
  moveModalConfirmText: {
    color: 'white',
    fontSize: 15,
    fontWeight: 'bold',
  },

  // QUICK TOAST
  quickToast: {
    position: 'absolute',
    top: 18,
    right: 18,
    backgroundColor: '#f3f3f3',
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 20,
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 9999,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 3,
    elevation: 3,
  },
  quickToastText: {
    color: 'black',
    fontWeight: '600',
    fontSize: 13,
  },

  // REWARD MODAL
  modalOverlayReward: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalCardReward: {
    width: 340,
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 25,
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    elevation: 6,
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 8,
  },
  tickCircleReward: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: '#00C851',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
  },
  mainTitleReward: {
    fontSize: 23,
    fontWeight: '800',
    textAlign: 'center',
    marginBottom: 8,
    color: 'black',
  },
  subTextReward: {
    fontSize: 16,
    color: '#333',
    textAlign: 'center',
    marginBottom: 15,
  },
  infoCardReward: {
    backgroundColor: '#f3f3f3',
    borderRadius: 12,
    padding: 18,
    marginBottom: 15,
    width: '100%',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 3,
  },
  infoTextReward: {
    fontSize: 15,
    color: '#333',
    textAlign: 'center',
    lineHeight: 22,
  },
  footerTextReward: {
    fontSize: 14,
    color: '#555',
    textAlign: 'center',
    marginBottom: 20,
  },
  buttonReward: {
    backgroundColor: 'black',
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 20,
  },
  buttonTextReward: {
    color: '#fff',
    fontWeight: '600',
    fontSize: 15,
  },
creatorSocialProofWrap: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignSelf: 'center',
  maxWidth: '92%',
  marginTop: 2,
  marginBottom: 10,
},
creatorProofBadge: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f7f7f7',
  borderWidth: 1,
  borderColor: '#e9e9e9',
  borderRadius: 999,
  paddingVertical: 5,
  paddingHorizontal: 9,
  marginHorizontal: 4,
  marginBottom: 6,
},
creatorProofIcon: {
  marginRight: 5,
},
creatorProofText: {
  fontSize: 14,
  color: '#444',
  fontWeight: '600',
  lineHeight: 14,
},
proposalInfoCard: {
  width: '100%',
  backgroundColor: '#eff6ff',
  borderWidth: 2,
  borderColor: '#2563eb',
  borderRadius: 18,
  padding: 16,
  marginBottom: 14,
  shadowColor: '#2563eb',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.12,
  shadowRadius: 14,
  elevation: 5,
},

proposalHeaderRow: {
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginBottom: 10,
},

proposalIconCircle: {
  width: 34,
  height: 34,
  borderRadius: 17,
  backgroundColor: '#ffffff',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 10,
  borderWidth: 1,
  borderColor: '#bfdbfe',
},

proposalBadgeRow: {
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginBottom: 6,
},

proposalTextBadge: {
  backgroundColor: '#2563eb',
  borderRadius: 999,
  paddingHorizontal: 10,
  paddingVertical: 4,
  marginRight: 6,
  marginBottom: 4,
},

proposalTextBadgeLabel: {
  color: '#ffffff',
  fontSize: 11,
  fontWeight: '900',
  letterSpacing: 0.4,
  textTransform: 'uppercase',
},

proposalSubBadge: {
  backgroundColor: '#dbeafe',
  borderColor: '#93c5fd',
  borderWidth: 1,
  borderRadius: 999,
  paddingHorizontal: 10,
  paddingVertical: 4,
  marginBottom: 4,
},

proposalSubBadgeLabel: {
  color: '#1e3a8a',
  fontSize: 11,
  fontWeight: '800',
},

proposalInfoTitle: {
  color: '#111827',
  fontSize: 17,
  fontWeight: '600',
  marginTop: 2,
},

proposalInfoBody: {
  color: '#1e3a8a',
  fontSize: 13,
  fontWeight: '500',
  lineHeight: 19,
},
proposalAcceptButton: {
  backgroundColor: '#2563eb',
  paddingVertical: 18,
  paddingHorizontal: 22,
  borderRadius: 18,
},

proposalAcceptButtonLabel: {
  color: '#fff',
  fontWeight: '800',
},
proposalAmendChip: {
  marginTop: 12,
  alignSelf: 'flex-start',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  borderWidth: 1,
  borderColor: '#bfdbfe',
  borderRadius: 999,
  paddingVertical: 8,
  paddingHorizontal: 12,
},

proposalAmendChipText: {
  color: '#2563eb',
  fontSize: 13,
  fontWeight: '700',
},
});

export default CollabCampaignDetails;
